// extracted by mini-css-extract-plugin
export default {"board":"Board_board__oyuz2","board-row":"Board_board-row__X8AWj"};